// extracted by mini-css-extract-plugin
export default {"root":"LogIn_root__QKXDh","root_form":"LogIn_root_form__ZrmTB","root_logo":"LogIn_root_logo__PzvpX","root_border":"LogIn_root_border__qtwDa"};